module.exports = __webpack_public_path__ + "static/media/print_new_black.811ac519.svg";